import React, { useState } from 'react'
import aggrementIcon from 'assets/Images/agreement-icon.svg'
import { PencilSimple, Trash } from '@phosphor-icons/react'
import { Switch } from 'antd'
import { AgreementResp } from 'types/agreement/agreement'
import { useDeleteAgreement } from 'api/Agreements/Agreeements'
import AlertModal from 'helper/AlertModal'
import {
  SwitchChangeEventHandler,
  SwitchClickEventHandler,
} from 'antd/lib/switch'

interface AgreementsFoundProps {
  agreements: AgreementResp[]
  selectedAgreement: AgreementResp
  setSelectedAgreement: React.Dispatch<React.SetStateAction<AgreementResp>>
  setOpenAddAgreementModal: React.Dispatch<React.SetStateAction<boolean>>
  selectedAgreementsIds: string[]
  setSelectedAgreementsIds: (state: string[]) => void
}

const AgreementsFound: React.FC<AgreementsFoundProps> = ({
  agreements,
  selectedAgreement,
  setSelectedAgreement,
  setOpenAddAgreementModal,
  selectedAgreementsIds,
  setSelectedAgreementsIds,
}) => {
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const {
    mutate: deleteAgreementMutation,
    isLoading: deleteAgreementMutationLoading,
  } = useDeleteAgreement()
  const handleEditClick = (item: AgreementResp) => {
    setSelectedAgreement(item)
    setOpenAddAgreementModal(true)
  }
  const handleDeleteClick = (item: AgreementResp) => {
    setSelectedAgreement(item)
    setAlertModal(true)
  }

  const handleYesDelete = () => {
    deleteAgreementMutation(selectedAgreement._id, {
      onSuccess: () => {
        setSelectedAgreement(undefined)
        setAlertModal(false)
      },
    })
  }

  const handleSwitchClick = (checked: boolean, item: AgreementResp) => {
    if (checked) {
      setSelectedAgreementsIds([...selectedAgreementsIds, item._id])
    } else {
      setSelectedAgreementsIds(
        selectedAgreementsIds.filter(id => id !== item._id),
      )
    }
  }

  return (
    <>
      {agreements.map((item, index) => {
        return (
          <div
            className="flex gap-20px align-start justify-between py-20px border-btm"
            key={index}
          >
            <div className="flex gap-10px align-start">
              <img src={aggrementIcon} alt="agreements-icon" />
              <p>{item.agreement}</p>
            </div>
            <div className="flex gap-10px align-center">
              <Trash
                className="pointer"
                size={20}
                color={'#ff6961'}
                onClick={() => handleDeleteClick(item)}
              />
              <PencilSimple
                className="pointer"
                size={20}
                color={'#000'}
                onClick={() => handleEditClick(item)}
              />
              <Switch
                checked={selectedAgreementsIds.includes(item._id)}
                onChange={e => handleSwitchClick(e, item)}
              />
            </div>
          </div>
        )
      })}

      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={{
            name: 'Agreement',
            heading: `Delete agreement`,
            message1: `Are you sure you want to delete this agreement?`,
          }}
          onYesClick={handleYesDelete}
          loading={deleteAgreementMutationLoading}
        />
      )}
    </>
  )
}

export default AgreementsFound
